import React from "react"
import { Link } from "gatsby"

import Layout from "./components/layout"
import SEO from "./components/seo"
import Donate from "./components/donate"

import me from "./images/me.jpg"

import "./blog-post-template.css"

const Template = ({ pageContext: { page } }) => (
  <Layout>
    <SEO title={page.frontmatter.title} description={page.frontmatter.description || page.excerpt} />

    {/* breadcrumbs */}
    <Link to="/blog">&lt; Blog</Link>

    <h1>{page.frontmatter.title}</h1>
    <div className="post-meta">
      <img src={me} style={{ height: '30px', width: '30px' }} />
      <span>
        Steve Baker, {page.frontmatter.date ? new Date(page.frontmatter.date).toDateString() : "Unknown Date"}
      </span>
    </div>

    <div className="label-container post-tags">
      {(parseTags(page.frontmatter.tags)).map(label => (
        <span className={"label card-label-grey"} key={label}>
          {label}
        </span>
      ))}
    </div>

    {/* {process.env.NODE_ENV === "development" && (
      <a href={"https://trello.com/c/" + page.id} target="_blank">
        Link to Contentful
      </a>
    )} */}

    <div
      className="blog-post-content"
      dangerouslySetInnerHTML={{ __html: page.html.replace("h1", "h2") }}
    />

    <i>
      Enjoy my content? Want to buy me some snacks and support this hungry developer?
    </i>
    <br />
    <Donate></Donate>

    <Link to="/blog">&lt; Blog</Link>
  </Layout>
)

const parseTags = tags => {

  return tags == null ? [] : (Array.isArray(tags) ? tags : tags?.replace(/ /g, ",").split(","));
}
export default Template
